import {
    Notification,
    NotificationDataType,
    TEACHER_COMMON_MENU_ITEMS,
    TEACHER_HELP_MENU_ITEMS,
} from '@yandex-int/k-common/typings';

import { getNotificationIdByElementId, getCurrentMenuNotifications } from './utils';

const ALL_NOTIFICATIONS = { ...TEACHER_COMMON_MENU_ITEMS, ...TEACHER_HELP_MENU_ITEMS };

export function getNotificationIds(notifications: Array<Notification<NotificationDataType>>) {
    const notificationValues = Object.values(ALL_NOTIFICATIONS);
    const menuNotifications = getCurrentMenuNotifications(notifications, notificationValues);

    return notificationValues.reduce(
        (obj, item) => ({ ...obj, [item]: getNotificationIdByElementId(menuNotifications, item) }),
        {} as Record<string, number | undefined>
    );
}
